import { Schema, model, models, Model } from "mongoose";
import { NetworkSymbols } from "based-auth/networks";

// Announcement Types
export interface IAnnouncement extends Document {
  _id: string;
  id?: string; // Added for transformed documents
  message: string;
  isActive: boolean;
  createdBy: {
    address: string;
    network: NetworkSymbols;
  };
  updatedBy: {
    address: string;
    network: NetworkSymbols;
  };
  createdAt: Date;
  updatedAt: Date;
}

const announcementSchema = new Schema<IAnnouncement>(
  {
    message: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    createdBy: {
      address: {
        type: String,
      },
      network: {
        enum: Object.values(NetworkSymbols),
        type: String,
      },
    },
    updatedBy: {
      address: {
        type: String,
      },
      network: {
        enum: Object.values(NetworkSymbols),
        type: String,
      },
    },
  },
  {
    timestamps: true,
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret.__v;
        delete ret._id;
      },
    },
  }
);

announcementSchema.index(
  { chainId: 1, account: 1, createdAt: -1 },
  { unique: true }
);

export const AnnouncementModel: Model<IAnnouncement> =
  models?.Announcement ||
  model<IAnnouncement>("Announcement", announcementSchema);
